import React from 'react';
import { usePostHog } from 'posthog-js/react';

export function withPostHog(Component) {
  return function WrappedComponent(props) {
    const posthog = usePostHog();
    return React.createElement(Component, { ...props, posthog: posthog });
  };
}
